import Lifecycle from "./Lifecycle";

export default Lifecycle;